import React, { useState } from 'react';
import { useSelector } from 'react-redux';

export default function MobileTabView({ tabComponents, onTabChange }) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [activeTab, setActiveTab] = useState('0');

  const handleChange = (newValue) => {
    setActiveTab(newValue);
    if (onTabChange) {
      onTabChange(tabComponents[newValue]?.id);
    }
  };
  return (
    <div className="div-flex-column rg-10">
      <div className="div-flex-row border-bottom padding-top-8">
        {tabComponents?.map((section, index) => (
          <div
            key={section.id}
            onClick={() => handleChange(index.toString())}
            role="button"
            tabIndex={0}
            className={
              activeTab === index.toString()
                ? `div-flex-row cg-20 ${section.borderColor} border-width-md py-1 div-flex-center`
                : 'div-flex-row cg-20 tab-common py-1 px-3 div-flex-center'
            }
          >
            <span
              className={`
                text-sm text-semi-bold ${section.textColor} ${section.indicator ? 'pulse-text' : ''}`}
            >
              {section.title}
            </span>
            <span
              className={`
                text-sm text-semi-bold ${section.textColor} ${section.indicator ? 'pulse-text' : ''}`}
            >
              {section.count}
            </span>
          </div>
        ))}
      </div>
      {tabComponents?.map(
        (section, index) =>
          activeTab === index.toString() && (
            <div
              key={section.id}
              className={`stage-dashboard-data-container left-padding right-padding theme-scrollable-container-${themeColor}`}
            >
              {section.component}
            </div>
          ),
      )}
    </div>
  );
}
